import React from 'react';
import { Phone, Mail, MapPin, Send, Clock } from 'lucide-react';
export function ContactPage() {
  return <div className="pt-44 pb-24" data-id="element-177">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-178">
        <div className="grid lg:grid-cols-2 gap-16" data-id="element-179">
          <div data-id="element-180">
            <h1 className="text-4xl md:text-5xl font-extrabold text-slate-900 mb-6" data-id="element-181">
              Get in Touch
            </h1>
            <p className="text-slate-600 text-lg mb-12 leading-relaxed" data-id="element-182">
              Have questions or ready to book your ride? Our team is here to
              help. Fill out the form or call us directly for immediate
              assistance.
            </p>

            <div className="space-y-8" data-id="element-183">
              <div className="flex items-start" data-id="element-184">
                <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mr-4 flex-shrink-0" data-id="element-185">
                  <Phone className="w-6 h-6 text-blue-600" data-id="element-186" />
                </div>
                <div data-id="element-187">
                  <h3 className="font-bold text-slate-900 mb-1 text-lg" data-id="element-188">
                    Call Us
                  </h3>
                  <p className="text-slate-600 mb-1" data-id="element-189">
                    Direct Line: (704) AMO-RIDE
                  </p>
                  <p className="text-blue-600 font-bold" data-id="element-190">
                    Available 24/7 for scheduling
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-191">
                <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mr-4 flex-shrink-0" data-id="element-192">
                  <Mail className="w-6 h-6 text-blue-600" data-id="element-193" />
                </div>
                <div data-id="element-194">
                  <h3 className="font-bold text-slate-900 mb-1 text-lg" data-id="element-195">
                    Email Us
                  </h3>
                  <p className="text-slate-600" data-id="element-196">info@amowts.com</p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-197">
                <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mr-4 flex-shrink-0" data-id="element-198">
                  <MapPin className="w-6 h-6 text-blue-600" data-id="element-199" />
                </div>
                <div data-id="element-200">
                  <h3 className="font-bold text-slate-900 mb-1 text-lg" data-id="element-201">
                    Service Area
                  </h3>
                  <p className="text-slate-600" data-id="element-202">
                    Charlotte, NC & Surrounding Areas
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white p-8 md:p-10 rounded-3xl shadow-2xl border border-slate-100" data-id="element-203">
            <h2 className="text-2xl font-bold text-slate-900 mb-8" data-id="element-204">
              Request a Quote / Book a Ride
            </h2>
            <form className="space-y-6" data-id="element-205">
              <div className="grid sm:grid-cols-2 gap-6" data-id="element-206">
                <div data-id="element-207">
                  <label className="block text-sm font-bold text-slate-700 mb-2" data-id="element-208">
                    Full Name
                  </label>
                  <input type="text" className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:border-blue-600 focus:ring-2 focus:ring-blue-100 outline-none transition-all" placeholder="John Doe" data-id="element-209" />
                </div>
                <div data-id="element-210">
                  <label className="block text-sm font-bold text-slate-700 mb-2" data-id="element-211">
                    Phone Number
                  </label>
                  <input type="tel" className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:border-blue-600 focus:ring-2 focus:ring-blue-100 outline-none transition-all" placeholder="(704) 000-0000" data-id="element-212" />
                </div>
              </div>
              <div data-id="element-213">
                <label className="block text-sm font-bold text-slate-700 mb-2" data-id="element-214">
                  Email Address
                </label>
                <input type="email" className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:border-blue-600 focus:ring-2 focus:ring-blue-100 outline-none transition-all" placeholder="john@example.com" data-id="element-215" />
              </div>
              <div data-id="element-216">
                <label className="block text-sm font-bold text-slate-700 mb-2" data-id="element-217">
                  Service Needed
                </label>
                <select className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:border-blue-600 focus:ring-2 focus:ring-blue-100 outline-none transition-all appearance-none bg-white" data-id="element-218">
                  <option data-id="element-219">Medical Appointment</option>
                  <option data-id="element-220">Dialysis Treatment</option>
                  <option data-id="element-221">Physical Therapy</option>
                  <option data-id="element-222">Social Outing</option>
                  <option data-id="element-223">Other</option>
                </select>
              </div>
              <div data-id="element-224">
                <label className="block text-sm font-bold text-slate-700 mb-2" data-id="element-225">
                  Message / Details
                </label>
                <textarea rows={4} className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:border-blue-600 focus:ring-2 focus:ring-blue-100 outline-none transition-all" placeholder="Please provide pickup location and any special requirements..." data-id="element-226"></textarea>
              </div>
              <button className="w-full bg-blue-600 text-white py-4 rounded-xl font-bold text-lg hover:bg-blue-700 transition-all shadow-lg flex items-center justify-center" data-id="element-227">
                <Send className="w-5 h-5 mr-2" data-id="element-228" />
                Send Request
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>;
}